// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"segment_wrapper__1mWfK","title":"segment_title__JizYy","collapsed":"segment_collapsed__PKxsi","actions":"segment_actions__BHWdA"};